<script setup lang="ts">
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

defineProps<{ documentId: string | None; draft?: boolean }>()

const init3 = useInited('init3')
const initAds = useInited('initAds')
const mobile = useMobile()
const locale = useLocale()
const elemSwiper = useTemplateRef('elemSwiper')
const elem = useTemplateRef('elem')

const data = shallowReactive({
  mounted: undefined as undefined | boolean,
  tags: undefined as undefined | boolean,
  swiper: undefined as undefined | boolean,
})

const timer = useTimeout()
const wait = (cb: () => unknown) => timer.set(() => cb(), 50)

const getClass = (i: string) => elem.value?.getElementsByClassName(i)

function mounted() {
  const go = (index: number): void => {
    if ((data.tags !== undefined && data.swiper !== undefined) || index > 50) return timer.clear()

    if (data.swiper === undefined) {
      const len = getClass('swiper')?.length
      if (len !== undefined) data.swiper = len > 0
    }
    if (data.tags === undefined) {
      const len = getClass('tag')?.length
      if (len !== undefined) data.tags = len > 0
    }
    data.mounted = true

    if (data.swiper === undefined || data.tags === undefined) wait(() => go(index + 1))
    else timer.clear()
  }

  wait(() => go(0))
}

onErrorCaptured((err) => console.error('[documentui]', err))
</script>

<template>
  <div ref="elem" class="_my-doc">
    <DocumentView v-if="documentId" :ref="() => mounted()" v-memo="[mobile, documentId, locale]" :mobile :draft :locale :document-id @vue:mounted="() => mounted()" />
    <ClientOnly>
      <LazyDocumentUiSwipers v-if="data.swiper" ref="elemSwiper" @vue:mounted="() => elemSwiper?.outSwiperInit(getClass('swiper'))" />
      <LazyDocumentUiTags v-if="init3" :elem="() => elem ?? undefined" />
      <LazyAdsDocumentUi v-if="data.mounted && initAds && documentId" :document-id :mobile />
    </ClientOnly>
  </div>
</template>

<style>
@import url(nuxt-base/assets/my-document.css);
</style>
